export const SET_MODAL = 'MODAL/SET_MODAL';
export const GET_MODAL = 'MODAL/GET_MODAL';
